module.exports = __webpack_public_path__ + "media/charte_selection/background-3d211a1f.webp";